import React, { useState } from 'react';

// Shows the Razorpay link ops just sent, so it can be copied and shared by hand if the
// SMS / WhatsApp does not reach the subscriber.
const PaymentLinkCard = ({ link, onResend, resending }) => {
  const [copied, setCopied] = useState(false);
  if (!link?.short_url) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link.short_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard can be blocked (insecure origin / permissions); the link stays selectable.
    }
  };

  return (
    <div className="mt-4 rounded-md border border-teal-200 bg-teal-50 px-4 py-3 text-sm">
      <div className="flex flex-wrap justify-between items-center gap-2">
        <span className="font-semibold text-teal-800">
          Payment link · ₹{Number(link.amount || 0).toFixed(2)}
        </span>
        {link.expires_at && (
          <span className="text-xs text-teal-700">
            Expires {new Date(link.expires_at * 1000).toLocaleString('en-IN')}
          </span>
        )}
      </div>
      <div className="mt-2 flex items-center gap-2">
        <input
          readOnly
          value={link.short_url}
          onFocus={(e) => e.target.select()}
          className="flex-1 min-w-0 px-3 py-1.5 border border-teal-200 rounded-md bg-white text-gray-700"
        />
        <button
          type="button"
          onClick={copy}
          className="px-3 py-1.5 border border-teal-600 rounded-md text-teal-700 hover:bg-teal-100 transition-colors font-medium"
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
        {onResend && (
          <button
            type="button"
            onClick={onResend}
            disabled={resending}
            className="px-3 py-1.5 border border-teal-600 rounded-md text-teal-700 hover:bg-teal-100 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {resending ? 'Sending…' : 'Resend'}
          </button>
        )}
      </div>
    </div>
  );
};

export default PaymentLinkCard;
